import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const API_BASE = API;
export const api = axios.create({ baseURL: API });
